<div class="request-details-container d-flex flex-column gap-4">
    <div class="d-flex align-items-start">
        <div class="request-details-header flex-grow-1 d-flex flex-column mb-3">
            <div class="d-flex align-items-center gap-3 mb-2">
                <button class="btn link-btn btn-back">
                    <i class="app-icon icon icon-chevron-left icon-xl" (click)="redirectListHandler()"></i>
                </button>
                <div class="request-details-type fw-bold">
                    {{request?.dictionaryRequestTypeName}}
                </div>
            </div>
    
            <div>
                {{'requests.details.category.dateOfRequest' | translate}}
                <span HJSuppress>{{request?.createdOn | localizedDate}}</span>
            </div>
            <div>
                {{'requests.details.category.requestInitiatedBy' | translate}}:
                <span HJSuppress class="fw-bold">{{ request?.createdByName | titlecase }}</span>
            </div>
        </div>

        <ng-container *ngIf="!isAdmin || request.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED">
            <div class="status-box">
                <div class="status-content">
                    <div class="status-dot" 
                        [ngClass]="request.dictionaryRequestStatus?.code===dictionaryRequestStatus.POSTED ? 'status-posted':
                                request.dictionaryRequestStatus?.code===dictionaryRequestStatus.IN_PROGRESS ? 'status-in-progress': 
                                request.dictionaryRequestStatus?.code===dictionaryRequestStatus.RESOLVED ? 'status-resolved': 
                                request.dictionaryRequestStatus?.code===dictionaryRequestStatus.CLOSED ? 'status-closed': ''">
                    </div>
                    <div class="status-value status-value-lg">{{ request.dictionaryRequestStatus?.value}}</div>
                </div>
            </div>
        </ng-container>
        
        <ng-container *ngIf="isAdmin && request?.dictionaryRequestStatus?.code!==dictionaryRequestStatus.CLOSED">
            <div class="status-box">
                <kendo-dropdownlist HJSuppress
                    id="status-dropdownlist" 
                    class="custom-kendo-control-xl request-status-dropdown k-picker-fill-none"
                    [fillMode]="fillModeNone" 
                    [rounded]="roundedLarge"
                    [size]="sizeLarge"
                    [(ngModel)]="statusId"
                    [data]="statuses"
                    [textField]="'value'"
                    [valueField]="'id'"
                    [valuePrimitive]="true"
                    [popupSettings]="{popupClass: 'request-status-dropdown-popup data-hj-suppress', appendTo : 'component'}"
                    (ngModelChange)="changeRequestStatus($event)"
                >
                    <ng-template kendoDropDownListValueTemplate kendoDropDownListItemTemplate let-status>
                        <div class="status-content">
                            <div class="status-dot"
                                [ngClass]="{
                                    'status-posted': status?.code === dictionaryRequestStatus.POSTED,
                                    'status-in-progress': status?.code === dictionaryRequestStatus.IN_PROGRESS,
                                    'status-resolved': status?.code === dictionaryRequestStatus.RESOLVED,
                                    'status-closed': status?.code === dictionaryRequestStatus.CLOSED,
                                    'status-default': ![dictionaryRequestStatus.POSTED, dictionaryRequestStatus.IN_PROGRESS, dictionaryRequestStatus.RESOLVED, dictionaryRequestStatus.CLOSED].includes(status?.code)
                                }"
                            ></div>
                            <div class="status-value status-value-lg">{{ status?.value }}</div>
                        </div>
                    </ng-template>
                </kendo-dropdownlist>
            </div>
        </ng-container>
    </div>

    <request-detail-category-selector class="mb-3" [selectedCategory]="selectedCategory"
        (categoryChange)="categoryChangeHandler($event)">
    </request-detail-category-selector>

    @switch (selectedCategory) {
    @case (REQUEST_DETAIL_CATEGORY.INFO){
    <div class="card">
        <div class="card-body">
            <ng-container *ngIf="request?.dictionaryRequestTypeCode === 'RQST_DRIVING_ABROAD'">
                <div class="detail-item-container">
                    <span class="detail-category">
                        {{'requests.details.category.contractAndAsset' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span class="detail-text">
                            {{'requests.details.contract' | translate}}
                            <span HJSuppress class="text-primary fw-bold">{{documentRequestHeader?.contractName}}</span>
                        </span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{'requests.details.asset' |
                            translate}}{{documentRequestHeader?.assetName}} {{request?.plateNumber}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.delegate' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.delegateName}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.additionalinsurance' | translate}}</span>
                    <span class="detail-item" *ngIf="request?.hasGreenInsurance">&bull;
                        <span class="detail-text">{{'requests.details.greenCardInsurance' | translate}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.transitCountries' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            <ng-container *ngFor="let country of request?.transitCountries; let indexCountry = index">
                                {{country.countryName}} {{indexCountry !== request?.transitCountries.length - 1 ? ", " : ""}}
                            </ng-container>
                        </span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'common.period' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{'requests.details.from' | translate}}
                            {{request?.transitFromDate | localizedDate}}
                            {{'requests.details.to' | translate}}
                            {{request?.transitToDate | localizedDate}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.dateOfRequest' | translate}}</span>
                    <span HJSuppress class="detail-item">&bull;
                        <span class="detail-text">{{request?.createdOn | localizedDate}}</span>
                    </span>
                </div>
            </ng-container>

            <ng-container *ngIf="request?.dictionaryRequestTypeCode === 'RQST_DAMAGE_DELEGACY'">
                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.contractAndAsset' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span class="detail-text">
                            {{'requests.details.contract' | translate}}
                            <span HJSuppress class="text-primary fw-bold">{{documentRequestHeader?.contractName}}</span>
                        </span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{'requests.details.asset' | translate}}{{documentRequestHeader?.assetName}} {{request?.plateNumber}}
                        </span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.delegate' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.delegateName}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.eventDateAndInsurer' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.eventDate | localizedDate}}</span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.insurerName}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.dateOfRequest' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.createdOn | localizedDate}}</span>
                    </span>
                </div>
            </ng-container>

            <ng-container *ngIf="request?.dictionaryRequestTypeCode === 'RQST_OTHER'">
                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.contractAndAsset' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span class="detail-text">
                            {{'requests.details.contract' | translate}}
                            <span HJSuppress class="text-primary fw-bold">{{documentRequestHeader?.contractName}}</span>
                        </span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{'requests.details.asset' | translate}}{{documentRequestHeader?.assetName}} {{request?.plateNumber}}
                        </span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.description' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.observations}}</span>
                    </span>
                </div>

                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.dateOfRequest' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.createdOn | localizedDate}}</span>
                    </span>
                </div>
            </ng-container>

            <ng-container *ngIf="request?.dictionaryRequestTypeCode === 'RQST_VIGNETTE'">
                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.contractAndAsset' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span class="detail-text">
                            {{'requests.details.contract' | translate}}
                            <span HJSuppress class="text-primary fw-bold">{{documentRequestHeader?.contractName}}</span>
                        </span>
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{'requests.details.asset' | translate}}{{documentRequestHeader?.assetName}} {{request?.plateNumber}}
                        </span>
                    </span>
                </div>
                <div class="detail-item-container">
                    <span class="detail-category">{{'requests.details.category.description' | translate}}</span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">{{request?.observations}}</span>
                    </span>
                </div>
                <div class="detail-item-container">
                    <span class="detail-category">
                        {{'requests.wizard.questions.ValabilityStartingDate' | translate}}
                    </span>
                    <span class="detail-item">&bull;
                        <span HJSuppress class="detail-text">
                            {{request?.eventDate | localizedDate}} 
                            {{ "request.VignetteValability" | translate: { vignette_valability: request?.vignetteValabilityPeriod } }}</span>
                    </span>
                </div>
            </ng-container>
        </div>
    </div>
    }
    @case (REQUEST_DETAIL_CATEGORY.DOCUMENTS) {
    <request-documents [requestId]="request.requestId" [requestTypeCode]="DICTIONARY_REQUEST_TYPES.ASSET_DOCUMENT"
        [selectedCategory]="selectedCategory">
    </request-documents>
    }
    @case (REQUEST_DETAIL_CATEGORY.COMMENTS) {
    <div class="card">
        <div class="card-body">
            <request-comment [requestId]="request.requestId" [requestTypeCode]="DICTIONARY_REQUEST_TYPES.ASSET_DOCUMENT"
                [selectedCategory]="selectedCategory">
            </request-comment>
        </div>
    </div>
    }
    }
</div>